export const environment = {
  production: false,
  apiUrl: 'https://api.kansinonederland.com/api/data' // Configure your API URL here
};

